import { Navigate } from 'react-router-dom';
import { lazy } from 'react';

// project imports
import MainLayout from 'views/components/layout/MainLayout';
import Loadable from 'views/components/ui-component/Loadable';
import DeviceRegister from '../views/pages/management/license/DeviceRegister';
import DeviceDetail from '../views/pages/management/license/DeviceDetail';
import DeviceEdit from '../views/pages/management/license/DeviceEdit';
import ClinicalDetail from '../views/pages/service/clinical/ClinicalDetail';

// lazy load all components
const User = Loadable(lazy(() => import('views/pages/management/user')));
const LicenseManagement = Loadable(lazy(() => import('views/pages/management/license')));
const UserInfo = Loadable(lazy(() => import('views/pages/authentication/user-auth/UserInfo')));
const UserEdit = Loadable(lazy(() => import('views/pages/authentication/user-auth/UserEdit')));
const UserRegister = Loadable(lazy(() => import('views/pages/management/user/UserRegister')));
const UserDetail = Loadable(lazy(() => import('views/pages/management/user/UserDetail')));
const UserPasswordChange = Loadable(lazy(() => import('views/pages/management/user/UserPasswordChange')));
const UserInfoEdit = Loadable(lazy(() => import('views/pages/management/user/UserEdit')));
const UserPasswordReset = Loadable(lazy(() => import('views/pages/management/user/UserPasswordReset')));

// ==============================|| IT STAFF ROUTES ||============================== //

const ITManagerRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            index: true,
            element: <Navigate to="/management/user" replace />
        },
        {
            path: 'management',
            children: [
                {
                    path: 'user',
                    children: [
                        {
                            path: '',
                            element: <User />
                        },
                        {
                            path: 'register',
                            element: <UserRegister />
                        },
                        {
                            path: ':id',
                            element: <UserDetail />
                        },
                        {
                            path: ':id/edit',
                            element: <UserInfoEdit />
                        },
                        {
                            path: ':id/password/reset',
                            element: <UserPasswordReset />
                        }
                    ]
                },
                {
                    path: 'license',
                    children: [
                        {
                            path: 'device/register',
                            element: <DeviceRegister />
                        },
                        {
                            path: 'device/:id',
                            element: <DeviceDetail />
                        },
                        {
                            path: 'device/:id/edit',
                            element: <DeviceEdit />
                        },
                        {
                            path: '',
                            element: <LicenseManagement />
                        },
                        {
                            path: '*',
                            element: <LicenseManagement />
                        }
                    ]
                }
            ]
        },
        {
            path: 'auth',
            children: [
                {
                    path: 'me',
                    element: <UserInfo />
                },
                {
                    path: 'me/edit',
                    element: <UserEdit />
                },
                {
                    path: 'password/change',
                    element: <UserPasswordChange />
                },
                {
                    path: 'password/reset',
                    element: <UserPasswordReset />
                }
            ]
        },
        {
            path: '*',
            element: <Navigate to="/management/user" replace />
        }
    ]
};

export default ITManagerRoutes;
